import { AfterViewInit, Component, TemplateRef, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AbilityService } from 'ability';
import { Alert, AlertService, MbsPopupType, MbsSize } from 'mbs-ui-kit';
import { RoutingPath } from 'mbs-ui-shared@constants/app-routing-path.enum';
import { ComputersFacade } from 'mbs-ui-shared@facades/computers.facade';
import { ComputersHealthFilterType } from 'mbs-ui-shared@models/Computer';
import { AppPersistentStateService } from 'mbs-ui-shared@services/app-persistent-state.service';
import { filter, switchMap, tap } from 'rxjs';

import { ButtonComponent } from 'mbs-ui-kit';

import { I18NextPipe } from 'angular-i18next';

import { CommonModule } from '@angular/common';

@Component({
  selector: 'mbs-unsupported-version',
  templateUrl: './unsupported-version.component.html',
  styleUrls: ['./unsupported-version.component.scss'],
  imports: [ButtonComponent, CommonModule, I18NextPipe]
})
export class UnsupportedVersionComponent implements AfterViewInit {
  private appStorage = inject(AppPersistentStateService);
  private facade = inject(ComputersFacade);
  private alertService = inject(AlertService);
  private ability = inject(AbilityService);
  private router = inject(Router);

  @ViewChild('alertTemplate', { static: true }) alertTemplate: TemplateRef<any>;
  public totalUnsupportedComputers: number;
  public MbsSize = MbsSize;

  public get isMultipleUnsupportedComputers(): boolean {
    return this.totalUnsupportedComputers > 1;
  }

  public get isRedirectEnabled(): boolean {
    return !this.router.url.endsWith(`${RoutingPath.ApComputers}?health=${ComputersHealthFilterType.Unsupported}`);
  }

  ngAfterViewInit(): void {
    if (this.appStorage.data.showUnsupportedVersionsMessage && this.ability.can('read', 'MBS')) {
      this.facade
        .getComputersCount({ type: 'unsupported' }, { 'x-front-queue': 'true' })
        .pipe(
          filter(Boolean),
          tap((total) => (this.totalUnsupportedComputers = total)),
          switchMap(() =>
            this.alertService.alert(new Alert({ content: this.alertTemplate, keepAfterRouteChange: true, type: MbsPopupType.danger }))
          )
        )
        .subscribe(() => this.disableUnsupportedVersionMessage());
    }
  }

  redirect() {
    this.isRedirectEnabled && (location.href = `${RoutingPath.ApComputers}?health=${ComputersHealthFilterType.Unsupported}&apply=true`);
  }

  private disableUnsupportedVersionMessage() {
    this.appStorage.data.showUnsupportedVersionsMessage = false;
  }
}
